import CloseIcon from "@mui/icons-material/Close";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { Box, Button, Modal, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Zoom from "@mui/material/Zoom";
import { useTheme } from "@mui/material/styles";
import { NavLink } from "react-router-dom";

function EmailBouncedModal({ showModal, handleCloseModal, t }) {
  const theme = useTheme();
  return (
    <Modal
      open={showModal}
      onClose={handleCloseModal}
      aria-labelledby="email-bounced-modal"
      aria-describedby={t("emailBouncedModalDescription")}
      sx={{
        overflowY: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& .MuiPaper-root": {
          position: "unset",
          zIndex: 20000,
          margin: "auto",
        },
      }}
    >
      <Zoom in={showModal}>
        <Paper
          elevation={2}
          sx={{
            display: "block",
            position: "absolute",
            top: 0,
            maxWidth: "600px",
            width: "100%",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 4,
            p: 3,
            minWidth: "280px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <Typography variant="h5" component="h2">
              {t("updateYourEmailAddress")}
            </Typography>
            <IconButton onClick={() => handleCloseModal()} sx={{ ml: "auto" }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box textAlign="center" my={2}>
            <WarningAmberRoundedIcon
              sx={{ fontSize: "3rem", color: theme.palette.warning.main }}
            />
          </Box>
          <Typography variant="p" component="p">
            {t("bouncedEmailDescription")}
          </Typography>
          <Box textAlign={"center"} my={1}>
            <NavLink to="/change-email" onClick={() => handleCloseModal()}>
              <Button variant="contained">{t("updateEmail")}</Button>
            </NavLink>
          </Box>
        </Paper>
      </Zoom>
    </Modal>
  );
}

export default EmailBouncedModal;
